// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"9c2e7f53","791":"500f9226"}[chunkId] + ".chunk.js";
};